import $ from 'jquery';

/**
 * Constructor function of Backdrop
 *
 * @public
 * @param {object} options
 * @param {jQuery node} parent Node
 */
export var Backdrop = function(options, isBackdropClickClose) {
    this._node = jQuery('<div class="ncUiBackdrop"></div>');

    this.onclicked = jQuery.Callbacks();

    this._parent = options._parent || jQuery('body');

    this._options = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'z-index': 100010,
        background: '#000',
        opacity: '0.8',
        filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=50)'
    };

    this._options.isBackdropClickClose = isBackdropClickClose;

    this._options = $.extend(this._options, options);

    this._options._parent = '';

    this._init();
};

Backdrop.prototype.show = function() {
    this._node.show();
};

Backdrop.prototype.hide = function() {
    this._node.hide();
};

Backdrop.prototype.remove = function() {
    this._node.remove();
};

Backdrop.prototype._init = function() {
    if (this._parent.has(this._node).length) {
        return this._node;
    }

    var cssOptions = this._options;
    cssOptions._parent = '';

    this._node.hide().css(cssOptions);
    this._parent.append(this._node);

    this.addEvent();

    return this._node;
};

Backdrop.prototype.addEvent = function() {
    var _this = this;
    this._node.click(function(evt) {
        if (_this._options.isBackdropClickClose) _this.onclicked.fire();
    });
};

/**
 * Constructor function of AbstractModal
 *
 * @public
 * @param {jQuery node} parent Node
 * @param {object} options
 */
var AbstractModal = function(options) {
    this._node = jQuery('<div class="ncUiModal"></div>');
    this._options = {
        _parent: jQuery('body'),
        type: '',
        url: '',
        w: '',
        h: '',
        content: '',
        isBackdrop: true,
        isBackdropClickClose: true,
        backdropCss: {},
        isEsc: false,
        isMove: false,
        top: 0,
        left: 0,
        movieParams: '?autoplay=1&version=3&enablejsapi=1',
        isAutoButton: false,
        isRemoveButton: false,
        hideCallback: function() {},
        showCallback: function() {}
    };

    this._options = $.extend(this._options, options);

    this._content = '';

    // create Backdrop
    this._options.backdropCss._parent = this._options._parent;
    this._backdrop = this._options.isBackdrop
        ? new Backdrop(this._options.backdropCss, this._options.isBackdropClickClose)
        : null;
};

AbstractModal.prototype.getNode = function() {
    return this._node;
};

AbstractModal.prototype._append = function() {
    this._options._parent.append(this._node);
};

AbstractModal.prototype.show = function() {
    if (this._backdrop) this._backdrop.show();
    this._node.show();
};

AbstractModal.prototype.remove = function() {
    if (this._backdrop) this._backdrop.remove();
    this._node.find('iframe').attr('src', '');
    this._node.remove();
};

AbstractModal.prototype.hide = function() {
    if (this._backdrop) this._backdrop.hide();
    this._node.hide();
};

AbstractModal.prototype._init = function() {
    this._append();
    this.setContent();
    this._setModal();
    this._setCloseButton();
    this._addEvent();
    this.hide();

    this._content.show();
};

AbstractModal.prototype.setContent = function() {
    this._content = jQuery(this._options.content).hide();
    this._node.append(this._content);
    this._options.w = this._content.outerWidth();
    this._options.h = this._content.outerHeight();
};

AbstractModal.prototype._setCloseButton = function(txt) {
    this._closeButton =
        this._content && this._content.find('.layerClose').length ? this._content.find('.layerClose') : [];

    if (this._closeButton.length === 0 && this._options.isAutoButton) {
        this._closeButton = jQuery('<span class="layerClose">' + (txt || 'close') + '</span>');
        this._node.append(this._closeButton);

        this._closeButton.css({
            position: 'absolute',
            'text-indent': '-119988px',
            cursor: 'pointer',
            'z-index': 100050
        });
    }
};

AbstractModal.prototype._addEvent = function() {
    var _this = this;
    if (this._backdrop) {
        this._backdrop.onclicked.add(function() {
            _this.hide();
        });
    }
};

AbstractModal.prototype._setModal = function() {
    var options = this._options,
        w = options.w || '90vw',
        h = options.h || '50.625vw';
    // scrollLeft = jQuery(window).scrollLeft();

    // var shadow = '0px 0px 20px rgba(0,0,0,0.6)',
    // 	radius = '3px';

    this._node
        .css({
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            width: '90vw',
            height: '50.625vw',
            'max-width': '160vh',
            'max-height': '90vh',
            margin: 'auto',
            // 'position': 'fixed',
            // 'left': '50%',
            // 'top': '50%',
            // 'marginTop': ( -h / 2 ),
            // 'marginLeft': ( -w / 2 ) + scrollLeft,
            // FIXME
            // '-webkit-box-shadow': shadow,
            // '-moz-box-shadow': shadow,
            // 'box-shadow': shadow,
            // '-webkit-border-radius': radius,
            // '-moz-border-radius': radius,
            // '-ms-border-radius': radius,
            // '-o-border-radius': radius,
            // 'border-radius': radius,
            // 'filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)',
            'z-index': 100020
        })
        .width(w)
        .height(h)
        .show();

    if (h > jQuery(window).height()) {
        this._node.css({ position: 'absolute' });
    }
};

/**
 * Constructor function of Modal
 *
 * @public
 * @param {jQuery node} parent Node
 * @param {object} options
 */
export var Modal = function(options) {
    this.modal = new AbstractModal(options);

    var opts = this.modal._options;

    this._url = opts.url + opts.movieParams;
    this._frame = '';

    if (opts.type === 'youtube') {
        this._init();
        this.modal.getNode().addClass('youtubeLayer');
    } else {
        this.modal._init();
    }

    this._addEvent();
};
Modal.prototype._isMovePosition = function() {
    var _modal = this.modal,
        _top = 0;
    // _left = 0;

    if (_modal._options.isMove) {
        if (_modal._options.top === 'auto') {
            _top = jQuery(window).scrollTop() + 30;
        } else {
            _top = _modal._options.top;
        }

        if (_modal._options.left != 'auto' && _modal._options.left != 0) {
            _modal._node.css({ 'margin-left': 0, left: _modal._options.left + 'px' });
        }

        _modal._node.css({ position: 'absolute', 'margin-top': 'auto', top: _top + 'px' });
    }
};
Modal.prototype._addEvent = function() {
    //FIXME
    var _this = this;
    if (this.modal._backdrop) {
        this.modal._backdrop.onclicked.add(function() {
            _this.hide();
        });
    }

    // jQuery( window ).resize( function(){
    //     var _modal = _this.modal;
    //     var h = _modal._options.h || 540;
    //
    //     if( h > jQuery( window ).height() ){
    //         _modal._node.css({'position': 'absolute', 'margin-top': 'auto', 'top': '50px'});
    //     }else{
    //         _modal._node.css({'position': 'fixed'});
    //     }
    //
    //     _this._isMovePosition();
    //
    // }).trigger( 'resize' );

    if (_this.modal._options.isEsc) {
        jQuery(window).on('keydown', function(evt) {
            if (evt.keyCode === 27) {
                _this.hide();
            }
        });
    }

    this.modal._closeButton.length &&
        this.modal._closeButton.click(function(evt) {
            evt.preventDefault();

            if (_this.modal._options.isRemoveButton) {
                _this.remove();
            } else {
                _this.hide();
            }
        });
};

Modal.prototype._init = function() {
    this.modal._append();
    this.modal._setModal();
    this.modal._setCloseButton();
    this.modal._addEvent();
    this.modal.hide();
};

Modal.prototype.changeContent = function(content) {
    // var options = this.modal._options;
    var modalContent = this.modal._content;

    modalContent.remove();

    modalContent = jQuery(content);
    this.modal._node.append(modalContent);
};

Modal.prototype.resetSize = function() {
    var options = this.modal._options;
    var modalContent = this.modal._content;

    options.w = modalContent.outerWidth();
    options.h = modalContent.outerHeight();

    this.modal._setModal();
    this._isMovePosition();
};
Modal.prototype.setYoutubeUrl = function(url) {
    this._url = url;
};

Modal.prototype.show = function() {
    var options = this.modal._options;

    if (options.type === 'youtube') {
        this._frame ? this._frame.attr('src', this._url + options.movieParams) : this.setContent();
    }

    this._isMovePosition();

    this.modal.show();

    options.showCallback && options.showCallback();
};

Modal.prototype.remove = function() {
    var options = this.modal._options;

    if (options.type === 'youtube') {
        if (this._frame) this._frame.remove();
    }

    this.modal.remove();
};

Modal.prototype.hide = function() {
    var options = this.modal._options;

    if (options.type === 'youtube') {
        if (this._frame) this._frame.attr('src', '');
    }

    this.modal.hide();
    options.hideCallback && options.hideCallback();
};

Modal.prototype.setContent = function() {
    var options = this.modal._options;
    // w = options.w,
    // h = options.h;

    this._frame = jQuery(
        '<iframe width="100%" height="100%" style="position: absolute; left: 0; top: 0;" src="' +
            this._url +
            options.movieParams +
            '" frameborder="0" allowfullscreen></iframe>'
    );
    this.modal._node.append(this._frame);
};
